import {useState, useCallback} from 'react';
import {isFunction} from '@Util/utils';

const useAnchorMenu = ({onOpen: onOpenProps, onClose: onCloseProps} = {}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = useCallback((e) => {
        setAnchorEl(e.currentTarget);
        if (isFunction(onOpenProps)) onOpenProps(e);
    },
        // eslint-disable-next-line
        [onOpenProps]);

    const handleClose = useCallback((e) => {
        setAnchorEl(null);
        if (isFunction(onCloseProps)) onCloseProps(e);
    },
        // eslint-disable-next-line
        [onCloseProps]);

    return {
        anchorEl,
        open,
        onOpen: handleOpen,
        onClose: handleClose,
    };
};

export default useAnchorMenu;
